import { useAuth } from '@aaas/shared';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { AppDashboard } from '../components/AppDashboard';

export function HomePage() {
  const { currentWorkspace, workspaceLoading, availableWorkspaces } = useAuth();
  const { t } = useTranslation('portal');

  // Show loading spinner while workspaces are being fetched
  if (workspaceLoading) {
    return (
      <div className="p-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-center h-64">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
              <p className="mt-4 text-gray-600">{t('home.loadingWorkspace')}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // If workspace is still being selected/switched, show loading
  if (!currentWorkspace && availableWorkspaces.length > 0) {
    return (
      <div className="p-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-center h-64">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
              <p className="mt-4 text-gray-600">{t('home.selectingWorkspace')}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // User has no workspaces at all — send to welcome page (header hidden there).
  if (!currentWorkspace && availableWorkspaces.length === 0) {
    return <Navigate to="/welcome" replace />;
  }

  // Render dashboard with current workspace
  return (
    <div className="p-8">
      <div className="max-w-7xl mx-auto">
        <AppDashboard
          workspaceId={currentWorkspace!.id}
          userRole={currentWorkspace!.role}
          workspaceName={currentWorkspace!.name}
        />
      </div>
    </div>
  );
}
